<template>
  <div class="about">
    <div class="container">
      <ShadowTitle :title="`Уникальное событие ТВОЕГО РАСШИРЕНИЯ`"
                   title-shadow="SPACE EVENT"/>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <div class="about-item">
            <img class="about-item_image" :src="require(`@/assets/about/about-1.svg`)">
            <div class="about-item_text">
              500 + участников, ищущих <br>возможности и ресурсы
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <div class="about-item">
            <img class="about-item_image" :src="require(`@/assets/about/about-2.svg`)">
            <div class="about-item_text">
              Иммерсивное <br>проживание опыта
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <div class="about-item">
            <img class="about-item_image" :src="require(`@/assets/about/about-3.svg`)">
            <div class="about-item_text">
              ТОП-эксперты <br>и селебрити
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <div class="about-item">
            <img class="about-item_image" :src="require(`@/assets/about/about-4.svg`)">
            <div class="about-item_text">
              Нетворкинг, новые форматы, <br>полезные связи
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "About",
  components: {ShadowTitle}
}
</script>

<style lang="scss" scoped>
.about-item {
  border-radius: 16px;
  background: linear-gradient(339deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.00) 21.35%, rgba(255, 255, 255, 0.00) 74.48%, rgba(255, 255, 255, 0.00) 100%), #0D0D10;
  box-shadow: 0 4px 76px 0 rgba(0, 0, 0, 0.60);
  padding: 26px 16px;
  display: flex;
  align-items: center;
  height: 100%;
  @include _768 {
    padding: 36px;
  }

  .about-item_image {
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }

  .about-item_text {
    color: var(--white, #FFF);
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 28.16px */
  }
}

</style>